const conUndsc = (...strings) => {
  return strings.join('_');
}

const createQuantifiers = (METHOD, MODEL) => {
  return {
    get SINGLE   () { return conUndsc(METHOD, 'SINGLE'   , MODEL) },
    get PARTIAL  () { return conUndsc(METHOD, 'PARTIAL'  , MODEL) },
    get MULTIPLE () { return conUndsc(METHOD, 'MULTIPLE' , MODEL) },
    get ALL      () { return conUndsc(METHOD, 'ALL'      , MODEL) },
  };
}

export const createActionTypeModel = (MODEL) => {
  return {
    GET    : { ...createQuantifiers('GET'    , MODEL ) },
    FETCH  : { ...createQuantifiers('FETCH'  , MODEL ) },
    SEARCH : { ...createQuantifiers('SEARCH' , MODEL ) },
    SET    : { ...createQuantifiers('SET'    , MODEL ) },
    INSERT : { ...createQuantifiers('INSERT' , MODEL ) },
    UPDATE : { ...createQuantifiers('UPDATE' , MODEL ) },
    DELETE : { ...createQuantifiers('DELETE' , MODEL ) },
    NAME: MODEL,
  }
}
export const createActionTypeModel1 = (MODEL) => {
  return {
    GET   : { ...createQuantifiers('GET'   , MODEL) },
    FETCH : { ...createQuantifiers('FETCH' , MODEL) },
    SEARCH : { ...createQuantifiers('SEARCH' , MODEL) },
    SET   : { ...createQuantifiers('SET'   , MODEL) },
    INSERT: { ...createQuantifiers('INSERT', MODEL) },
    UPDATE: { ...createQuantifiers('UPDATE', MODEL) },
    DELETE: { ...createQuantifiers('DELETE', MODEL) },
    NAME: MODEL,
  }
}
export const createActionTypeModel3 = (MODEL) => {
  return {
    get GET    () { return createQuantifiers('GET'    , MODEL); },
    get FETCH  () { return createQuantifiers('FETCH'  , MODEL); },
    get SEARCH () { return createQuantifiers('SEARCH' , MODEL); },
    get SET    () { return createQuantifiers('SET'    , MODEL); },
    get INSERT () { return createQuantifiers('INSERT' , MODEL); },
    get UPDATE () { return createQuantifiers('UPDATE' , MODEL); },
    get DELETE () { return createQuantifiers('DELETE' , MODEL); },
    NAME: MODEL,
  }
}


const Files = createActionTypeModel('Files');

Files.INSERT.MULTIPLE;
Files.INSERT.MULTIPLE;
Files.INSERT.MULTIPLE;
Files.INSERT.MULTIPLE;

const DOCS = createActionTypeModel('Files');

DOCS.INSERT.MULTIPLE;
DOCS.INSERT.MULTIPLE_DATASTATE;
DOCS.INSERT.MULTIPLE;
DOCS.INSERT.MULTIPLE;